"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSpinner = void 0;

var React = _interopRequireWildcard(require("react"));

var _iconFactory = _interopRequireDefault(require("./utils/iconFactory"));

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const Spinner = (_ref) => {
  let color = _ref.color,
      baseColor = _ref.baseColor,
      baseColor1 = _ref.baseColor1,
      detailsColor = _ref.detailsColor,
      detailsColor1 = _ref.detailsColor1,
      baseColor2 = _ref.baseColor2,
      detailsColor2 = _ref.detailsColor2,
      rest = _objectWithoutProperties(_ref, ["color", "baseColor", "baseColor1", "detailsColor", "detailsColor1", "baseColor2", "detailsColor2"]);

  return (0, _core.jsx)("svg", _extends({}, rest, {
    fill: color
  }), (0, _core.jsx)("path", {
    className: "cr-icon__base cr-icon__base-2",
    fill: baseColor || baseColor2,
    d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-3A5 5 0 1 0 8 3a5 5 0 0 0 0 10z",
    opacity: ".3"
  }), (0, _core.jsx)("path", {
    className: "cr-icon__base cr-icon__base-1",
    fill: baseColor || baseColor1,
    d: "M8 13a1.5 1.5 0 0 1 0 3A8 8 0 0 1 .323 5.742a1.5 1.5 0 1 1 2.879.846A5 5 0 0 0 8 13z"
  }));
};

const NextIcon = (0, _iconFactory.default)(Spinner, 'IconSpinner');
exports.IconSpinner = NextIcon;